import React from "react";
import _ from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";

import IFilter from "models/IFilter";
import Input from "components/Input";
import Select from "components/Select";
import DetailView from "components/DetailView";
import RangeDatepicker from "components/RangeDatepicker";
import Button from "components/Button";
import FilterGenerator from "helpers/filter";
import withFilters from "helpers/withFilters";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps extends IFilter {
  typeOptions: any[];
}

class InvoicesSearch extends React.Component<IProps> {
  public static getInputQuery = (value) => {
    const Q = new FilterGenerator();

    Q.and("Number", value);
    Q.or("CounterParty/Name", value);
    Q.or("CounterParty/Number", value);
    Q.or("Lines", value, "array", "Item/CultivarCode");
    Q.or("Lines", value, "array", "Item/Description");
    Q.or("Lines", value, "array", "Description");

    return Q.query;
  };

  public static getFilterQuery = (f) => {
    const Q = new FilterGenerator();
    const status = _.get(f, "status.value");

    if (!_.isEmpty(f.paymentDate)) {
      Q.and("PaymentDate", f.paymentDate, "dateRange");
    }
    if (!_.isEmpty(f.date)) {
      Q.and("InvoiceDate", f.date, "dateRange");
    }
    Q.and("Number", f.invoiceNumber);
    Q.and("CounterParty/Name", f.counterPartyName);
    Q.and("PurchaseType", f.type, "select");
    Q.and("Order/Number", f.orderNumber);
    Q.and("InvoiceTypePortal", f.invoiceType, "select");
    if (status) {
      Q.addText(`${Q.query && "and "}RemainingAmount ${status} 0`);
    }
    Q.and("CounterParty/Number", f.counterPartyNumber);
    if (f.description) {
      const checkQuery = Q.query ? true : false;
      checkQuery && Q.addText("and (");
      Q.without("Lines", f.description, "array", "Item/CultivarCode");
      Q.or("Lines", f.description, "array", "Item/Description");
      Q.or("Lines", f.description, "array", "Description");
      checkQuery && Q.addText(")");
    }

    return Q.query;
  };

  public render = () => {
    const {
      filter,
      handleFilterChange,
      generateFilter,
      resetFilter,
      intl: { formatMessage },
      roleIds = [],
      typeOptions,
    } = this.props;

    return (
      <DetailView
        pageName={CUSTOM_SETTINGS.invoices}
        renderExpanded={() => (
          <div>
            <div className="filter-row">
              <div className="inner-block">
                <FormattedMessage id="PURCHASE_TYPE" tagName="label" />
                <Select
                  options={roleIds}
                  selectedOption={filter.type}
                  onChange={(value) => handleFilterChange(value, "type")}
                  className="min-width-select-forms"
                />
              </div>
              <div className="inner-block">
                <FormattedMessage id="STATUS" tagName="label" />
                <Select
                  options={[
                    { value: "ne", label: formatMessage({ id: "OPEN" }) },
                    { value: null, label: formatMessage({ id: "BOTH" }) },
                    { value: "eq", label: formatMessage({ id: "CLOSED" }) },
                  ]}
                  selectedOption={filter.status}
                  onChange={(value) => handleFilterChange(value, "status")}
                  className="min-width-select-forms"
                />
              </div>
            </div>
            <div className="filter-row">
              <RangeDatepicker
                name="date"
                label="DATE"
                value={filter.date}
                handleRangeChange={handleFilterChange}
              />
              <Input
                label="ORDERS_NUMBER"
                value={filter.orderNumber}
                onChange={(e) =>
                  handleFilterChange(e.target.value, "orderNumber")
                }
              />
            </div>
            <div className="filter-row">
              <div className="inner-block">
                <FormattedMessage id="INVOICES_KIND" tagName="label" />
                <Select
                  options={typeOptions}
                  selectedOption={filter.invoiceType}
                  onChange={(value) => handleFilterChange(value, "invoiceType")}
                  className="min-width-select-forms"
                />
              </div>
              <RangeDatepicker
                name="paymentDate"
                label="PAYMENT_DATE"
                value={filter.paymentDate}
                handleRangeChange={handleFilterChange}
              />
            </div>
          </div>
        )}
      >
        <div className="filter-row">
          <Input
            label="INVOICES_NUMBER"
            value={filter.invoiceNumber}
            onChange={(e) =>
              handleFilterChange(e.target.value, "invoiceNumber")
            }
          />
          <Input
            label="COUNTERPARTY_NAME"
            value={filter.counterPartyName}
            onChange={(e) =>
              handleFilterChange(e.target.value, "counterPartyName")
            }
          />
        </div>
        <div className="filter-row">
          <Input
            label="ARTICLE_DESCRIPTION"
            value={filter.description}
            onChange={(e) => handleFilterChange(e.target.value, "description")}
          />
          <Input
            label="COUNTERPARTY_NUMBER"
            value={filter.counterPartyNumber}
            onChange={(e) =>
              handleFilterChange(e.target.value, "counterPartyNumber")
            }
          />
        </div>
        <div className="search-btn">
          <Button onClick={resetFilter}>RESET</Button>
          <Button kind="primary" onClick={generateFilter}>
            SEARCH
          </Button>
        </div>
      </DetailView>
    );
  };
}

export default withFilters({
  placeholder: "INVOICES_SEARCH",
  pageName: CUSTOM_SETTINGS.invoices,
})(injectIntl(InvoicesSearch));
